const dotenv = require('dotenv');
dotenv.config();
module.exports = {
  AUTH0_DOMAIN: process.env.REACT_APP_AUTH0_DOMAIN,
  AUTH0_CLIENT_ID: process.env.REACT_APP_AUTH0_CLIENT_ID,
  COMMENT_SERVER_URL: process.env.REACT_APP_COMMENT_SERVER_URL,
  FILE_SERVER_URL: process.env.REACT_APP_FILE_SERVER_URL,
};